import React from 'react';
import styled from 'styled-components';

import { TextColorInterface } from './config/CommonInterfaces';

const H1 = styled.h1<{tc: string, placement: string}>`
  font-family: 'Open Sans', sans-serif;
  font-size: 2.2rem;
  color: ${({ tc, theme: { colors }}) => colors.text[`${tc}`.toUpperCase()]};
  text-align: ${({ placement }) => placement};
`;

const H2 = styled.h2<{tc: string}>`
  font-family: 'Open Sans', sans-serif;
  font-size: 2rem;
  color: ${({ tc, theme: { colors }}) => colors.text[`${tc}`.toUpperCase()]};
`;

const H3 = styled.h3<{tc: string, placement: string}>`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: ${({ tc, theme: { colors }}) => colors.text[`${tc}`.toUpperCase()]};
  font-size: 1rem;
  text-align: ${({ placement }) => placement};
`;

const Paragraph = styled.p<{tc: string}>`
  font-family: 'Montserrat', sans-serif;
  color: ${({ tc, theme: { colors }}) => colors.text[`${tc}`.toUpperCase()]};
`;

const Label = styled.label<{tc: string}>`
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  color: ${({ tc, theme: { colors }}) => colors.text[`${tc}`.toUpperCase()]};
  font-size: 0.8rem;
`;


const renderLevel = (l: string, text: string, color: string, placement: string) => {
  switch (l) {
    case 'h1':
      return <H1 tc={color} placement={placement}>{ text }</H1>
    case 'h2':
      return <H2 tc={color}>{ text }</H2>
    case 'h3':
      return <H3 tc={color} placement={placement}>{ text }</H3>
    case 'label':
      return <Label tc={color}>{ text }</Label>  
  
    default:
      return <Paragraph tc={color}>{ text }</Paragraph>
  }
}

interface TextProps extends TextColorInterface {
  level: 'h1' | 'h2' | 'h3' | 'paragraph' | 'label',
  children: string,
  placement: 'left' | 'right' | 'center';
}

function Text({
  level, children, textColor,
  placement,
}: TextProps) {
  return renderLevel(level, children, textColor, placement);
}

export default Text;

Text.defaultProps = {
  level: 'paragraph',
  children: null,
  textColor: 'normal',
  placement: 'left',
}
